import { GameObject } from '../base/GameObject';
import { Earth } from './Earth';
import Phaser from 'phaser';

export class NeutronEarth extends Earth {
  protected override getAtmosphereColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getEnergyColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getParticleColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getShieldColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getCoreColor(): number {
    throw new Error('Method not implemented.');
  }
  constructor(scene: Phaser.Scene, x: number, y: number) {
    // Call parent constructor with proper parameters
    super(scene, x, y, 2000, 0.15, 5, 22000, 0);
    
    // Set specific properties
    this.damageResistance = 0.15;
    this.specialAbility = 'GravityField';
    this.abilityCooldown = 22000;
  }

  override useSpecialAbility(): void {
    this.activateGravityField();
  }

  override activateAbility(): void {
    this.playAbilityEffect();
    this.activateGravityField();
  }

  private activateGravityField(): void {
    // Slow all monsters 50% trong 3.5s
    const slowAmount = 0.5;
    const slowDuration = 3500; // ms
    const monsters = this.scene.children.list.filter(child =>
      child instanceof GameObject &&
      child.x !== undefined && child.y !== undefined &&
      typeof (child as any).applySlow === 'function'
    ) as GameObject[];
    for (const m of monsters) {
      (m as any).applySlow(slowAmount, slowDuration);
    }
  }

  override upgrade(): void {
    this.level++;
    this.baseMaxHealth += 300;
    this.baseDefense += 0.02;
    this.damageResistance += 0.02;
    this.recalculateStats();
    this.health = this.effectiveMaxHealth;
  }
} 